'use client'

import DetailBox from '@/features/veluvit/components/detail/detail-box'
import { useCatalogMedia } from '@/features/veluvit/hooks/use-app-data'
import { productCopy } from '@/features/veluvit/lib/format'
import { workFor } from '@/features/veluvit/lib/rules'

/**
 * 작품 소개 — 스튜디오 작품 › 공개 설정의 `상세 설명`(Chat.description, 1,000자) 한 단락.
 * 2026-10-08 스튜디오 기획으로 정리 — 옛 레퍼런스 블록(관전 포인트 · 주의 · 한눈에 보기)은 스튜디오에 입력 칸이 없어 걷었다.
 * 서버 작품 설명이 없을 때(정적 시드)만 원문 소개 · 긴 한 줄 소개로 대신한다.
 */
export default function IntroBox({ id }: { id: string }) {
  const { catalog } = useCatalogMedia()
  const c = catalog.chars[id]
  const text =
    workFor(catalog, id)?.description || c.introText || productCopy(c.hookLong)
  if (!text) return null
  return (
    <DetailBox title="작품 소개">
      <p className="mt-3 text-c14 leading-[1.85] whitespace-pre-line text-t2 [overflow-wrap:anywhere] over10:text-c15">
        {text}
      </p>
    </DetailBox>
  )
}
